import { planBTTypes } from "./planBT.types"

 
 export const setIsLoadingListPlanBTAction = (isLoading: boolean) => ({
    type: planBTTypes.IS_LOADING_LIST_PLANBT,
    payload: isLoading
 })

 export const setQuerySearchAction = (querySearch: string | null) => ({
    type: planBTTypes.SET_QUERY_SEARCH,
    payload: querySearch
 })
 
 const planBTActions = {
    setIsLoadingListPlanBTAction,
    setQuerySearchAction
}

export default planBTActions